<template>
  <div class="animated fadeIn">
  <b-row class="justify-content-center">
    <b-col lg="11" xl="8">
    <b-card v-show="showList">
      <div slot="header">{{this.$route.meta.title}}
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="9">
          <b-input-group>
              <b-input-group-prepend><label style="width:90px !important;">Filter</label></b-input-group-prepend>
              <b-form-input v-model="filter.iteminfo" @keyup.13.native="refresh()" placeholder="Name"></b-form-input>          
              <!-- <b-form-input v-model="filter.crewnik" @keyup.13.native="refresh()" placeholder="Employee ID" class="ml-1"></b-form-input>               -->
              <b-input-group-append> <span class="pl-2 pt-2 pr-1"> Group </span></b-input-group-append>
              <b-form-select v-model="filter.customer_group" :plain="true" :options="customerGroups" ></b-form-select>
          </b-input-group>          
        </b-col>
        <b-col lg="3">
                <b-button variant="success" size="sm" @click="refresh()"><i class="fa fa-refresh"></i> Apply Filter</b-button>
                <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()">Clear Filter</b-button>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:cell(nomor)="data">
          {{ data.index +1}}
        </template>
        <template v-slot:cell(iklan)="data">
          <span v-if="data.item.iklan==1"><i class="fa fa-check "></i></span>
        </template>
        <template v-slot:cell(koran)="data">
          <span v-if="data.item.koran==1"><i class="fa fa-check "></i></span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div >
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-input-group style="width: 200px;">
              <b-input-group-prepend class="mb-0"><span class="p-1">Limit per page</span></b-input-group-prepend>
              <b-form-input v-model="tblData.limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${tblData.limit} records`" style="max-width:80px; !important;"></b-form-input>  
            </b-input-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    </b-col>
  </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
         <b-card >
            <div slot="header">Item Cust. Group - Add/Edit Form </div>
                  <b-input-group >
                        <b-input-group-prepend><label>Item</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.iteminfo" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="lkuItemShow=true" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Customer Group</label></b-input-group-prepend>
                    <b-form-select v-model="frmdata.customer_group" :plain="true" :options="custgroups" ></b-form-select>                   
                  </b-input-group>


            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>

      </b-col>
    </b-row>
        <!-- <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true" :lazy="true">
            <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
        </b-modal>         -->
  </div>
</template>

<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 160px;
            }
        }
    }
</style>

<script>
import toastr from "mini-toastr";
// import lkuCrew from "../lookup/lkuCrewlazzy";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        itemno:{required},
        customer_group:{required}
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      lkuCrewShow: false,
      lkuCrewData: [],
      custgroups:[],
      showList:true,
      showForm:false,
      frmdata:{crewnik: '', iklan:0, isPaket:0, crewkey:'',JenisKomp:'', rumus:'', SifatKomp:'', koran:'', IdFrm1721:'' },
      tblData: {
        tablename:'vwitemcustomergroup',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'itemname',
        sortDesc: true
      },
      tblFields:[
          {
            key: "iteminfo",
            label: "Item Info",
            sortable: true
          },
          {
            key: "customer_group",
            // label: "ustomer_group",
            sortable: true
          },
          // {
          //   key: "crewnik",
          //   label: "Employee ID",
          //   sortable: true
          // },
        ],      
      filter:{},
      YesNo :   [{ value: 0, text: 'YES' }, { value: 1, text: 'NO' }],
      customerGroups:[{value:'', text:'--ALL--'},{value:'KONSINYASI', text:'KONSINYASI'}, {value:'WHOLESALE', text:'WHOLESALE'}],
      user: this.$store.state.user
    };
  },
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  created: async function() {
    this.tblData.customQuery = this.crudfilter;    
      this.tblFields.push( 
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          },
      );   
    const custGroup = await crud.list({
      tablename:'customergroupmaster',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'group_name',
        sortDesc: true
    }); 

    this.custgroups =custGroup.reduce((arr=[],obj)=>{
        arr.push({ value: obj.group_code, text: obj.group_name });
        return arr;
    },[])

  },  
  methods: {
    onSelectLkuCrew: function (lkuData) {
        this.frmdata.crewinfo = lkuData.selected.crewname.trim() + ' | ' + lkuData.selected.crewnik.trim();
        this.frmdata.crewkey = lkuData.selected.crewkey;
        this.frmdata.salesae_name = lkuData.selected.crewname.trim().toUpperCase();
        this.lkuCrewData=lkuData;
        this.lkuCrewShow=false;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      let str='';
      if (this.filter.iteminfo){
        str = 'iteminfo=%' + encodeURIComponent(this.filter.iteminfo)+'%';
      }
      if (this.filter.customer_group) {
        str += str ? "&" : "";
        str =
          str +
          "customer_group=" +
          encodeURIComponent(this.filter.customer_group) +
          "%";
      }
      // if (this.filter.salesae_name){
      //   str += str ? '&' : '';
      //   str = str + 'salesae_name=' + encodeURIComponent(this.filter.salesae_name)+'%';
      // }
      this.tblData.customQuery=str;

      const list = await crud.list(this.tblData);      
      return list;
    },
    clearFilter(ctx) {
      this.tblData.salesae_name = "";
      this.tblData.crewnik = "";
      this.filter.iteminfo = "";
      this.filter.customer_group = "";
      this.refresh();
    },    
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
        this.$router.push({name:'bakery.itemcustomergroupfrm'});
    },
    edit: async function(data) {
      console.log('data',data);
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.tablekey;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
    this.frmdata.iklan=this.frmdata.iklan || '0';                   
    this.frmdata.koran= this.frmdata.koran || '0';              

        if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.frmdata.idlama) {
                await crud.update(
                     {tablename:'itemcustomergroup', 
                     key:this.frmdata.idlama, 
                     data:{
                         itemno:this.frmdata.itemno,                   
                        customer_group:this.frmdata.customer_group}
                      });
              } else {
                await crud.insert(
                  { tablename:'itemcustomergroup',                      
                     data:{itemno:this.frmdata.itemno,                   
                        customer_group:this.frmdata.customer_group}
                  });
              }
              this.closeFrm();   
              this.refresh();               
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },      
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'salesae', key:this.model.salesae_id});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$route.name !==this.$store.state.prevRoute.name)) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
          router.push({name: "bakery"});
      }

    },    
  }
};
</script>
